import React, {Component} from 'react';
import ContactSearch from "../Boilerplate/ContactSearch";
import {compose} from "redux";
import {connect} from "react-redux";
import {codeProjectionArray} from "../../projections";
import {getProjectContacts, removeProjectContact} from "../../actions/projectcontacts";
import {RoutedTabsFactory} from "../Boilerplate/RoutedTabs";
import {ContactsView} from "../Boilerplate/ContactsView";
import {Route, Switch} from "react-router";
import {CodeTag} from "../Boilerplate/CodeTag";
import {codeTables} from "../../codes";
import * as R from 'ramda';
import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis
import {getMyCompany} from "../../actions/companies";
import {clearUserSearch, getUsersQuery} from "../../actions/users";
import {
  inviteUser,
  inviteUserContactLists,
  inviteUserEmails,
  updateProjectInvitePermissions
} from "../../actions/projects";
import {CodeSingleSelect} from "../Boilerplate/CodeSingleSelect";
import {Button, Card, Icon, Tooltip} from "antd";
import {currentEffectiveUserId, searchState} from "../../reducers/ui";
import SearchBox from "../Boilerplate/SearchBox";

// --------------------------------------------------------------------------------
// ---------------------------------  COMPONENTS  ---------------------------------
// --------------------------------------------------------------------------------

class ProjectContacts extends Component {
  state = { searchTerm: null };

  getTabs = () => {
    const { company } = this.props;

    return [
      {
        key: 'mycompany',
        text: company ? company.companyname : 'Loading...',
        dest: params => `/projects/${params.id}/contacts/mycompany`,
        selected: { path: `/projects/:id/contacts/mycompany` }
      },
      {
        key: 'all',
        text: 'Project Contacts',
        dest: params => `/projects/${params.id}/contacts/`,
        selected: { path: `/projects/:id/contacts/`, exact: true }
      },
      {
        key: 'planholders',
        text: 'Plan Holders',
        dest: params => `/projects/${params.id}/contacts/planholders`,
        selected: { path: `/projects/:id/contacts/planholders` }
      },
      {
        key: 'email',
        text: 'Email Invites',
        dest: params => `/projects/${params.id}/contacts/email`,
        selected: { path: `/projects/:id/contacts/email` }
      },
    ];
  };

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  handleSearch = searchTerm => {
    this.setState({ searchTerm });
  };

  extras = (handleInvite, onDelete) => (contact) => {
    if (contact['active']) {
      return <CodeTag table='bidinvitestatus' code={'pending'}/>
    } else {
      return <Button onClick={() => handleInvite(contact)}>Invite</Button>
    }
  };

  render() {
    const { searchResults, searchState, onNewInvites, onSearch, onInvite, onSearchMount, onEmailInvite, onContactListInvite, cache = {} } = this.props;
    const { searchTerm = null } = this.state;
    const extras = this.extras;
    const ProjectContactsNavBar = RoutedTabsFactory(this.getTabs(), 'all', {type: 'card'});
    const contactCount = cache.size ?
      <strong>{cache.size}</strong> :
      <React.Fragment><Icon type={'loading'}/> loading...</React.Fragment>;
    return (
      <div>
        <Switch>
          <Route exact path='/projects/:id/contacts/new' render={props => (
            <React.Fragment>
              <ContactSearch
                searchState={searchState}
                searchResults={searchResults}
                onBack={() => props.history.goBack()}
                onMount={onSearchMount}
                onSearch={onSearch}
                onInvite={onInvite}
                onEmailInvite={onEmailInvite}
                onContactListInvite={onContactListInvite}
                extras={extras}
              />
            </React.Fragment>
          )}/>
          <Route render={props => (
            <React.Fragment>
              <Card
                title={<ProjectContactsNavBar/>}
                extra={<React.Fragment>
                  <Button icon='user-add' onClick={onNewInvites}>New Invites</Button>
                </React.Fragment>}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
                  <span>Total contacts across all tabs: {contactCount}</span>
                  <SearchBox
                    placeholder="Search tabs by name, company, email, phone, city, or state"
                    onChange={this.handleSearch}
                    className='contact-search control-search'
                    interactive
                  />
                </div>
                {
                  searchTerm ?
                    <React.Fragment>
                      <SearchProjectContacts searchTerm={searchTerm} match={this.props.match}/>
                    </React.Fragment> :
                    <React.Fragment>
                      <Route exact path='/projects/:id/contacts/' component={AllProjectContacts}/>
                      <Route path='/projects/:id/contacts/mycompany' component={MyCompanyProjectContacts}/>
                      <Route path='/projects/:id/contacts/planholders' component={PlanHolderProjectInvites}/>
                      <Route path='/projects/:id/contacts/email' component={EmailProjectInvites}/>
                    </React.Fragment>
                }
              </Card>
            </React.Fragment>
          )}/>
        </Switch>
      </div>
    );
  }
}

const _ProjectCardExtras = ({ contact, currentUser, permissions, onDelete, onChangeRole, owners, myCompany }) => (
  <React.Fragment>
    {
      contact.userinitialized &&
      <CodeSingleSelect
        allowClear size='small'
        style={{ width: 100 }}
        codes={codeTables.get('projectrole')}
        value={contact.role}
        onChange={onChangeRole}
        disabled={!(permissions.update && !owners.includes(contact.contactuserid) && contact.contactuserid !== currentUser)}
      />
    }
    {
      !(owners.includes(contact.contactuserid))
        ? <React.Fragment>
          {currentUser !== contact.contactuserid &&
          <Tooltip title={'Remove user from project'}><Button size='small' icon='user-delete' onClick={onDelete}/></Tooltip>}
        </React.Fragment>
        : null
    }
  </React.Fragment>
);

// --------------------------------------------------------------------------------
// ----------------------------------  SELECTORS  ---------------------------------
// --------------------------------------------------------------------------------

const getProfile = state => R.view(R.lensPath(['profile']), state);

const _getMyCompany = createSelector(
  getProfile,
  state => state.companies,
  (profile, companies) => R.path(['data', profile.companyid, 'resource'], companies)
);

const getCurrentProjectId = (state, props) => props.match.params.id;

const getContactsCache = createSelector(
  getCurrentProjectId,
  state => R.path(['projectcontacts','data'], state),
  (projectId, projectContacts) => R.path([projectId, 'cache'], projectContacts)
);

const getCurrentProject = createSelector(
  getCurrentProjectId,
  state => state.view,
  (projectId, view) => R.path(['data', projectId], view)
);

const getCurrentProjectPermissions = createSelector(
  getCurrentProject,
  (project) => project.permissions
);

const getCurrentProjectContactList = createSelector(
  getCurrentProjectId,
  state => state.projectcontacts,
  (projectId, projectcontacts) => projectcontacts.data[projectId]
);

const getCurrentProjectOwners = createSelector(
  getCurrentProject,
  ({resource: {createdbyuserid, owneruserid}}) => [createdbyuserid, owneruserid]
);

const mergedContacts = createSelector(
  getCurrentProjectContactList,
  state => state.ui.userSearchResults,
  (projectContacts, searchContacts) => {
    projectContacts = projectContacts || {};
    return searchContacts.map(id => {
      if (projectContacts[id])
        return projectContacts[id];
      else
        return { contactuserid: id };
    });
  }
);

const _getAllContacts = createSelector(
  getCurrentProjectContactList,
  (list) => {
    if (!list) return [];
    list = Object.values(list);
    return list;
  }
);

const searchContacts = createSelector(
  _getAllContacts,
  state => state.companies,
  (state, props) => new RegExp(props.searchTerm, 'i'),
  (list, companies, search) => list.filter(contact => {
    const company = R.path(['data', contact.companyid, 'resource'], companies) || {};
    // Extract searchable fields from user object and user company object
    const obj = (
      ({ firstname, lastname, title, email, phone, cell, fax, company: { companyname, address, address2, city, state, zip } }
      ) => ({ firstname, lastname, title, email, phone, cell, fax, companyname, address, address2, city, state, zip })
    )({ ...contact, company });
    return Object.values(obj)
      .map(i => search.test(i)) // Test search term against each field
      .filter(i => i).length; // Grab only results with one or more match
  })
);

const getAllContacts = createSelector(
  _getAllContacts,
  (list) => list.filter(contact => contact.userinitialized)
);

const getMyCompanyContacts = createSelector(
  _getAllContacts,
  getProfile,
  (list, profile) => list.filter((
    contact => contact.companyid === profile.companyid
  ))
);

const getPlanHolderInvites = createSelector(
  _getAllContacts,
  (list) => list.filter(contact => contact.viewed)
);

const getEmailInvites = createSelector(
  _getAllContacts,
  (list) => list.filter(contact => contact.hasOwnProperty('userinitialized') && !contact.userinitialized)
);

// --------------------------------------------------------------------------------
// -----------------------------------  MAPPERS  ----------------------------------
// --------------------------------------------------------------------------------

// const mapCodes = (list, state) => list.map(codeProjectionArray(['role'], codeTables.get('projectrole')));

const mapDispatchMaster = (dispatch, props) => {
  const {
    match: {
      params: { id }
    },
    history
  } = props;
  return {
    onMount: () => {
      dispatch(getMyCompany());
      return dispatch(getProjectContacts(id));
    },
    onSearchMount: () => dispatch(clearUserSearch()),
    onNewInvites: () => history.push(`/projects/${id}/contacts/new`),
    onSearch: (value) => dispatch(getUsersQuery(value)),
    onInvite: (contact) => dispatch(inviteUser(id, contact.contactuserid)),
    onEmailInvite: (emails) => dispatch(inviteUserEmails(id, emails)),
    onContactListInvite: (contactlists) => dispatch(inviteUserContactLists(id, contactlists)),
  };
};

const mapDispatchTabs = (dispatch, props) => {
  const {
    match: {
      params: { id }
    },
    history
  } = props;
  return {
    onSearch: (value) => dispatch(getUsersQuery(value)),
    onInvite: (contact) => dispatch(inviteUser(id, contact.contactuserid)),
    onEmailInvite: (emails) => dispatch(inviteUserEmails(id, emails)),
    onContactListInvite: (contactlists) => dispatch(inviteUserContactLists(id, contactlists)),
    path: ['projectcontacts', 'data', id],
  };
};

// --------------------------------------------------------------------------------
// ---------------------------------  CONNECTORS  ---------------------------------
// --------------------------------------------------------------------------------

const ProjectCardExtras = connect(
  (state, props) => ({
    currentUser: currentEffectiveUserId(state),
    owners: getCurrentProjectOwners(state, props),
    myCompany: getMyCompanyContacts(state, props).map(contact => contact.contactuserid),
    permissions: getCurrentProjectPermissions(state, props),
  }),
  (dispatch, props) => ({
    onDelete: () => dispatch(removeProjectContact(props.contact.projectid, props.contact.contactuserid)),
    onChangeRole: (role) => dispatch(updateProjectInvitePermissions(props.contact.projectid, props.contact.contactuserid, role || null))
  })
)(_ProjectCardExtras);

const getContacts = filterContacts => compose(
  connect(
    (state, props) => {
      let list = filterContacts(state, props);
      // list = mapCodes(list, state);
      let projectId = getCurrentProjectId(state, props);
      return {
        contacts: list,
        cache: getContactsCache(state, props),
        extras: contact => <ProjectCardExtras {...props} contact={contact} projectId={projectId}/>,
      };
    },
    mapDispatchTabs
  )
)(ContactsView);

const SearchProjectContacts = getContacts(searchContacts);
const AllProjectContacts = getContacts(getAllContacts);
const MyCompanyProjectContacts = getContacts(getMyCompanyContacts);
const PlanHolderProjectInvites = getContacts(getPlanHolderInvites);
const EmailProjectInvites = getContacts(getEmailInvites);

export default connect(
  (state, props) => ({
    profile: getProfile(state),
    company: _getMyCompany(state),
    cache: getContactsCache(state, props),
    searchResults: mergedContacts(state, props),
    searchState: searchState(state, props),
  }),
  mapDispatchMaster
)(ProjectContacts);



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectContacts.js